import { CustomFilter } from 'app/ComponentLibrary/Filter';
import React, { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { selectUser } from 'oidc/user.selectors';
import { Concatenate } from 'utils/string/string';
import { defaultValues, getPlacementRecruiterFilterSpec } from './MyPerformanceFilterUtils';
import { selectRecruiterOptions } from '../MyPerformance.selector';
import { myPerformanceActions } from '../MyPerformance.redux';

interface IMyPerformanceFilterProps {
  onApplyFilter: (values: Record<string, unknown>) => void;
  onReset?: () => void;
  hideResetButton?: boolean;
}

export const MyPerformanceFilter = ({ onApplyFilter, onReset, hideResetButton }: IMyPerformanceFilterProps) => {
  const dispatch = useDispatch();
  const { setValue } = useFormContext();
  const recruiterOptions = useSelector(selectRecruiterOptions);
  const { userInfo } = useSelector(selectUser) ?? {};

  const fields = useMemo(() => getPlacementRecruiterFilterSpec(recruiterOptions), [recruiterOptions]);

  const resetFilter = () => {
    if (userInfo?.employeeId) {
      const label = Concatenate([userInfo.firstName ?? '', userInfo.lastName ?? ''], ' ');
      const placementRecruiter = {
        id: userInfo.employeeId,
        name: label,
        value: userInfo.employeeId,
        object: { userId: userInfo.employeeId, firstName: userInfo.firstName, lastName: userInfo.lastName },
      };
      const newFilter = { ...defaultValues, placementRecruiter };
      Object.entries(newFilter).forEach(([key, val]) => setValue(key, val));

      dispatch(myPerformanceActions.setSelectedEmployeeId(userInfo.employeeId));
      onApplyFilter(newFilter);
    }
  };

  return (
    <CustomFilter
      fields={fields}
      onResetForm={() => (onReset ?? resetFilter)()}
      resetBtn={hideResetButton}
      justifyContent="flex-start"
      version2
      analytics={{
        caller: 'Recruiter WorkDesk',
        onApply: true,
        properties: { category: 'My Performance' },
      }}
    />
  );
};
